
/**
 * @class
 * @description Model for the label to display on map
 * 
 */
export class Label {

    /**
     * 
     * @param {string} name Label name
     * @param {string} html HTML code displayed on map
     * @param {number} latitude Latitude for label coordinates
     * @param {number} longitude  Longitude for label coordinates
     */
    constructor(name, html, latitude, longitude) {
        this.name = name;
        this.html = html;
        this.coordinates = {
            latitude: latitude,
            longitude: longitude
        };
    }
}  